var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 44,
    viewBox: "0 0 99 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81845 0.800049V18.7505L15.1466 26.4001L1.07031 34.5191L16.6429 43.4667L31.4951 34.9334V17.8667L1.81845 0.800049Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56641 34.5192L16.6427 42.6383V26.4277L2.56641 34.5192Z",
    fill: "#ED3B7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56641 2.0979V18.3084L16.6427 10.1894L2.56641 2.0979Z",
    fill: "#FCB832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6427 10.1895L2.56641 18.3085L16.6427 26.4276V10.1895Z",
    fill: "#F79420"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7446 34.5193V18.3086L16.6406 26.4278L30.7446 34.5193Z",
    fill: "#7B1B66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 26.4276L30.7446 18.3085L16.6406 10.1895V26.4276Z",
    fill: "#F05A22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7446 34.5192L16.6406 26.4277V42.6383L30.7446 34.5192Z",
    fill: "#C30C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6445 34.8781H98.9395V32.1165V26.6485C98.9395 25.8199 98.9395 18.5018 98.9395 18.5018V17.5905V16.0715C98.4685 16.2097 96.3626 16.7895 95.2819 18.0599C94.8108 18.557 94.6445 19.2474 94.6445 19.855V32.4202V34.8781Z",
    fill: "#EC1C24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7015 16.1548C55.1042 16.1548 50.7539 20.3524 50.7539 25.7099C50.7539 31.0397 55.0765 35.2097 60.6183 35.2097C66.1879 35.2097 70.5936 31.0397 70.5936 25.6823C70.5936 20.3524 66.2434 16.1548 60.7015 16.1548ZM60.7015 31.5368C57.4872 31.5368 55.0488 29.0237 55.0488 25.6823C55.0488 22.3131 57.4594 19.8 60.6183 19.8C63.8049 19.8 66.2711 22.396 66.2711 25.7099C66.2711 29.0237 63.888 31.5368 60.7015 31.5368Z",
    fill: "#EC1C24"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5892 16.2377C80.9291 16.2377 78.934 17.3146 77.2714 19.5515C77.2714 18.6954 77.2714 11.3772 77.2714 11.3772V10.4659V8.94702C76.8004 9.08509 74.7222 9.66504 73.6138 10.9354C73.1705 11.4048 72.9766 12.1228 72.9766 12.7304V25.2957V27.9745V34.8783H77.2714C77.2714 34.8783 77.2714 32.8073 77.2714 32.1445C78.8232 34.2157 80.9291 35.2926 83.5892 35.2926C87.801 35.2926 92.2899 31.9235 92.2899 25.7099C92.2899 19.5515 87.801 16.2377 83.5892 16.2377ZM82.6193 31.6197C79.5713 31.6197 77.3822 29.1343 77.3822 25.7099C77.3822 22.3959 79.6545 19.8829 82.6193 19.8829C85.6951 19.8829 87.9395 22.3407 87.9395 25.7099C87.9395 29.2447 85.8059 31.6197 82.6193 31.6197Z",
    fill: "#EC1C24"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2812 34.8781H43.5761V27.7531C43.5761 23.6659 45.7375 21.0977 49.5059 20.7662C50.0047 20.7386 50.5588 20.6282 50.5588 19.8273V16.403H50.0324C47.1784 16.403 44.9062 17.8666 43.5761 20.4073C43.5761 19.4959 43.5761 16.0991 43.5761 16.0991V16.0715C43.1051 16.2097 41.0269 16.7895 39.8908 18.0599C39.4751 18.5294 39.2812 19.2474 39.2812 19.855V20.9043V34.8781Z",
    fill: "#EC1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobi);
export default __webpack_public_path__ + "static/media/robi.370dab6c1d6a3f4c56e714ecc0c8b97f.svg";
export { ForwardRef as ReactComponent };